// extracted by mini-css-extract-plugin
module.exports =  {"content":"_93444fe79c--content--ruefw","title":"_93444fe79c--title--i99HN","link-container":"_93444fe79c--link-container--PhoNC","link":"_93444fe79c--link--Z_4h7"};